import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4fc42ae0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4fc42ae0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc42ae0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fc42ae0')) {
      api.createRecord('4fc42ae0', component.options)
    } else {
      api.reload('4fc42ae0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4fc42ae0&scoped=true", function () {
      api.rerender('4fc42ae0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/myTypes/index.vue"
export default component.exports